import React from "react";
import { Facebook } from "lucide-react";
import AIStudioTool from "./AIStudioTool";

const FIELDS = [
  { key: "product_name", label: "Product name", required: true, wide: true,
    placeholder: "e.g. Sunrise Oats — Vanilla Almond",
    hint: "The consumer-facing product being promoted." },

  { key: "brand_name", label: "Brand name",
    placeholder: "e.g. Sunrise",
    hint: "Optional. Helps the AI reference the brand voice." },

  { key: "category", label: "Category", required: true,
    placeholder: "e.g. Overnight oats, functional beverage…" },

  { key: "campaign_goal", label: "Campaign objective", type: "select",
    options: [
      { value: "conversions", label: "Conversions (buy now)" },
      { value: "traffic",     label: "Traffic (visit site)" },
      { value: "awareness",   label: "Awareness (reach)" },
      { value: "engagement",  label: "Engagement (likes/comments)" },
      { value: "lead_gen",    label: "Lead generation (signups)" },
      { value: "video_views", label: "Video views" },
    ],
    hint: "The Meta objective to optimise for." },

  { key: "target_audience", label: "Target audience", type: "textarea", rows: 2, wide: true,
    placeholder: "e.g. Millennials 25-40 in urban US, wellness-curious, buy from Whole Foods…",
    hint: "Age, interests, behaviours, geography — the AI will suggest lookalikes.",
    maxLength: 400 },

  { key: "key_benefits", label: "Key benefits / hooks", type: "textarea", rows: 2, wide: true,
    placeholder: "e.g. 20g protein, zero refined sugar, 5-minute breakfast, ready-to-eat…",
    maxLength: 600 },

  { key: "offer", label: "Offer or promo",
    placeholder: "e.g. 20% off first order, free shipping, BOGO on 3-packs",
    hint: "Optional. Adds urgency to the copy variations." },

  { key: "style", label: "Creative style",
    placeholder: "e.g. scroll-stopping, editorial, meme-adjacent, UGC-style",
    hint: "Design mood for the ad creatives." },

  { key: "count",   label: "Creatives to generate", type: "number", min: 1, max: 4,
    hint: "Copy variations are always 3 per generation — this only affects images." },

  { key: "quality", label: "Render quality", type: "select",
    options: [
      { value: "low",    label: "Low — fastest" },
      { value: "medium", label: "Medium — balanced (recommended)" },
      { value: "high",   label: "High — slower, portfolio-ready" },
    ] },
];

const DEFAULTS = {
  product_name: "", brand_name: "", category: "", campaign_goal: "conversions",
  target_audience: "", key_benefits: "", offer: "",
  style: "scroll-stopping, editorial, modern",
  count: 2, quality: "medium",
};

export default function AIStudioMetaAds() {
  return (
    <AIStudioTool
      toolSlug="meta-ads"
      name="Meta Ads Manager"
      Icon={Facebook}
      tagline="Plan a Facebook & Instagram campaign end-to-end. Warren's AI drafts the audience, placements, and 3 copy variations, then renders scroll-stopping creatives you can plug straight into Ads Manager."
      fields={FIELDS}
      endpoint="/ai-studio/meta-ads/generate"
      defaultValues={DEFAULTS}
      cta="Generate campaign brief + creatives"
      historyLabel="Your Meta campaigns"
      formHeading="Brief the campaign"
    />
  );
}
